// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root___FUfm","rootSmall":"AddTileButton_rootSmall__2z04f"};